const root = 'ProductSearchForm'
const primarySearchInput = `${root}-primarySearchInput`

export const TestId = {
  primarySearchInput,
  primarySearchInputClearButton: `${primarySearchInput}-clearButton`,
  primarySearchInputSubmitButton: `${primarySearchInput}-submitButton`,
}
